// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#main-container[data-v-785c65b6] {\n  height: calc(var(--vh) * 100);\n  overflow: auto;\n}\n.show-bottom[data-v-785c65b6] {\n  padding-bottom: 1.33333rem !important;\n  height: calc(var(--vh) * 100 - 1.33333rem) !important;\n}\n", ""]);
// Exports
module.exports = exports;
